import script from "./GraciousDonors.vue?vue&type=script&lang=ts&setup=true"
export * from "./GraciousDonors.vue?vue&type=script&lang=ts&setup=true"

import "./GraciousDonors.vue?vue&type=style&index=0&id=760fb89a&scoped=true&lang=scss"
import "./GraciousDonors.vue?vue&type=style&index=1&id=760fb89a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-760fb89a"]])

export default __exports__